import React, { FC, ReactElement, useEffect } from 'react';
import { Theme, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useQueryClient } from 'react-query';
import RootContainer from './routes/rootContainer';
import { ThemeProviderWrapper } from '../context/ThemeContext';
import featureFlag from '../config/featureFlag';

declare module '@mui/styles/defaultTheme' {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface DefaultTheme extends Theme {}
}

interface AppContainerProps {}

const useLogQueries = () => {
    const queryClient = useQueryClient();

    useEffect(() => {
        const logQueries = () => {
            const queries = queryClient.getQueryCache().getAll();
            queries.forEach((query) => {
                console.log({
                    queryKey: query.queryKey,
                    status: query.state.status,
                    isFetching: query.isFetching(),
                    isStale: query.isStale(),
                    isActive: query.isActive(),
                    data: query.state.data,
                });
            });
        };

        let unsubscribe;

        if (featureFlag.queryDebugLogs.active) {
            unsubscribe = queryClient.getQueryCache().subscribe(logQueries);
            logQueries();
        }
        return () => {
            unsubscribe?.();
        };
    }, [queryClient]);
};

const AppContainer: FC<AppContainerProps> = (): ReactElement => {
    console.log('Log from AppContainer');
    useLogQueries();

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProviderWrapper>
                <CssBaseline />
                <RootContainer />
            </ThemeProviderWrapper>
        </StyledEngineProvider>
    );
};

export default AppContainer;
